import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Keeps a single <link rel="canonical"> in sync with the current route.
 *
 * HeirWise is reachable at both the apex (heirwise.app) and www host. The apex
 * is the canonical host — it is what robots.txt, sitemap.xml and og:url use —
 * so every route self-canonicalises to `https://heirwise.app<pathname>`.
 */
const CANONICAL_ORIGIN = "https://heirwise.app";

export default function CanonicalTag() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const href = `${CANONICAL_ORIGIN}${path}`;

    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = href;

    const og = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (og) og.content = href;
  }, [pathname]);

  return null;
}
